import { createSlice } from '@reduxjs/toolkit';

import type * as DetailViewTypes from './types';

const name = 'detailView';

const initialState: DetailViewTypes.DetailViewState = {
    showActivitySidebar: true,
    showMobileContentPanel: false,
    showFullscreen: false,
    playFloorGameUp: false,
    playFloorGameDown: false,
    goBack: false,
};

export const detailViewSlice = createSlice({
    name,
    initialState,
    reducers: {
        resetDetailViewStore() {
            return initialState;
        },
        setShowActivitySidebar(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, showActivitySidebar: payload };
        },
        setShowMobileContentPanel(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, showMobileContentPanel: payload };
        },
        setFullscreen(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, showFullscreen: payload };
        },
        setPlayFloorGameUp(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, playFloorGameUp: payload };
        },
        setPlayFloorGameDown(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, playFloorGameDown: payload };
        },
        setGoBack(state, { payload }: DetailViewTypes.SetExpandedActivityAction) {
            return { ...state, goBack: payload };
        },
    },
});
